import Locales from 'components/Locales'
import ScrollTop from 'components/ScrollTop'
import MaintenancePage from 'components/MaintenancePage'

import { Auth0ProviderWrapper } from 'contexts/Auth0ProviderWrapper'
import { AuthProvider } from 'contexts/AuthContext'
import { BreadcrumbActionsProvider } from 'contexts/BreadcrumbActionsContext'
import { ConfigProvider } from 'contexts/ConfigContext'
import { SSEProvider } from 'contexts/SSEContext'
import { GlobalStateProvider } from 'contexts/GlobalStateContext'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import ThemeCustomization from 'themes'

import Hotjar from '@hotjar/browser'

import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
// scroll bar
import 'simplebar-react/dist/simplebar.min.css'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
// google-fonts
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'

import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'

import '@fontsource/inter/600.css'

import '@fontsource/inter/700.css'
import '@fontsource/poppins/400.css'

import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'

import '@fontsource/poppins/700.css'
import '@fontsource/public-sans/400.css'
import '@fontsource/public-sans/500.css'

import '@fontsource/public-sans/600.css'
import '@fontsource/public-sans/700.css'
import '@fontsource/dm-sans/400.css'
import '@fontsource/dm-sans/500.css'
import '@fontsource/dm-sans/600.css'
import '@fontsource/dm-sans/700.css'

const container = document.getElementById('root')
const root = createRoot(container!)

const siteId = process.env.REACT_APP_HOTJAR_SITE_ID
const hotjarVersion = 6
const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE === 'true'

if (siteId && hotjarVersion) {
  Hotjar.init(Number(siteId), Number(hotjarVersion))
}

// Register the service worker
// the prompting for reload should be removed and we should just reload the page when a
// new version is available. this prompt is here for testing purposes. We will see if
// this works in production.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting && window.confirm('New version available! Do you want to reload?')) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      window.location.reload()
    }
  },
})

root.render(
  <ConfigProvider>
    <ThemeCustomization>
      {isMaintenanceMode ? (
        <MaintenancePage />
      ) : (
        <Locales>
          <ScrollTop>
            <BrowserRouter basename={process.env.REACT_APP_BASE_NAME || '/'}>
              <Auth0ProviderWrapper>
                <AuthProvider>
                  <GlobalStateProvider>
                    <SSEProvider>
                      <BreadcrumbActionsProvider>
                        <App />
                      </BreadcrumbActionsProvider>
                    </SSEProvider>
                  </GlobalStateProvider>
                </AuthProvider>
              </Auth0ProviderWrapper>
            </BrowserRouter>
          </ScrollTop>
        </Locales>
      )}
    </ThemeCustomization>
  </ConfigProvider>
)

reportWebVitals()
